import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {errorlist} from '../providers/errorlist';
import { ChangePassword } from '../models/user';

import { AuthService } from '../providers/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from '../../environments/environment.prod';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  type1 = "password";
  type2 = "password";
  type3 = "password";
  errorlist:any;
  public userData:ChangePassword = {oldpassword: null, password: null, cnfpassword: null};
  currentUser:any = {};
  constructor(private auth : AuthService, private router: Router, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.errorlist = errorlist;
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
   
  }

  togglePassword(type, nameVariable){
    if (type == "password"){
      this[nameVariable] = "text";
    }
    else {
      this[nameVariable] = "password";
    }
  }

  changepasswordUser(){
    console.log(this.userData)
    this.spinnerService.show();
    let sid = localStorage.getItem('sid');
    this.userData['sid'] = sid;
    console.log(this.userData)
    this.auth.change_password(this.userData).then((user) => {
      console.log(user.json());
      let response = user.json();
      if(response.replyCode == "error"){
        this.spinnerService.hide();
        this.auth.open(response.replyMsg);
      }else{
        this.userData = {};
        this.spinnerService.hide();
        this.auth.open(response.replyMsg);
        this.router.navigateByUrl('view-profile');
      }
    })
    .catch((err) => {
      this.spinnerService.hide();
      console.log(err);
      this.auth.open(environment.error)
    });
  }
  logout(){
    this.auth.changeLoginStatus(false);
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('sid');
   this.router.navigate(['/']);
 }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/change-password/change-password.component.ts